export default "__VITE_ASSET__hxMmIkN3__"